import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import {useHistory} from 'react-router-dom'


const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory()

  function Greeting(props) {
    const myStorage = window.localStorage;
  
    // localStorage.clear()
    const hasStorage=myStorage.length>0

    let productHeader=null
    if(hasStorage){
     productHeader=
       <Stack direction="row" spacing={2} alignItems="center">
         <Avatar alt={myStorage.username} src="avatar.png" >
         </Avatar>
         <p> 
         {myStorage.username || "Profile"}
         </p>
      <Button
            className="logout-button"
            variant="text"
            onClick={() =>{
              localStorage.clear();
              window.location.reload()
              
            } }
          >
            LOGOUT
            
      </Button>
       </Stack>
      return productHeader
    } else{
      productHeader =<Stack direction="row" spacing={2} alignItems="center">
            <Button
            className="explore-button"
            variant="text"
            onClick={() => history.push("/login", { from: "Header" })}
          >
            LOGIN
           </Button>
           <Button className="button" onClick={() => history.push("/register", { from: "Header" })} variant="contained">
                 Register
            </Button>
      </Stack>
      return productHeader
    }
  }


    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        <div className="mt-10">{children}</div>
        { hasHiddenAuthButtons 
        ?
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/", { from: "Header" })}
        >
          Back to explore
        </Button>
        : <Greeting/>
        }
        
      </Box>
    );
};

export default Header;
